/* eslint-disable no-param-reassign */
import Vue from 'vue';
import { utcToZonedTime, format } from 'date-fns-tz';
import chatModule from './chat';
import database from '../firebase/database';
import firestore from '../firebase/firestore';
import notifications from '../plugins/tl-notifications';
import firChat from '../firebase/chat';

const defaultTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const tripModule = {
  modules: { chat: chatModule },
  state: {
    observingFeed: false,
    postComments: {},
    trip: null,
    events: {},
    travels: {},
    flights: {},
    cities: {},
    chats: {},
    files: {},
    maps: {},
    feed: {},
    scheduled: {},
    contacts: {},
    surveys: {},
    polls: {},
    subgroups: {},
  },
  mutations: {
    postCommentAdded: (state, payload) => {
      if (!state.postComments[payload.postId]) {
        Vue.set(state.postComments, payload.postId, [payload.document]);
      } else {
        state.postComments[payload.postId].push(payload.document);
      }
    },
    updateTripCollectionDocument: (state, payload) => {
      Vue.set(state[payload.collection], payload.document.id, payload.document);
    },
    deleteTripCollectionDocument: (state, payload) => {
      Vue.delete(state[payload.collection], payload.documentId);
    },
    updateTripDocument: (state, payload) => {
      state[payload.collection] = payload.document;
    },
    updateTripDatabaseChild: (state, payload) => {
      Vue.set(state[payload.collection], payload.document.id, payload.document.value);
    },

    deleteTrip: (state) => {
      state.observingFeed = false;
      state.postComments = {};
      state.trip = null;
      state.events = {};
      state.travels = {};
      state.flights = {};
      state.cities = {};
      state.chats = {};
      state.files = {};
      state.maps = {};
      state.feed = {};
      state.scheduled = {};
      state.contacts = {};
      state.surveys = {};
      state.polls = {};
      state.subgroups = {};
      state.chat.conversations = {};
    },
  },
  getters: {
    sortedItinerary: (state, getters) => {
      const activities = [
        ...Object.values(state.events),
        ...Object.values(state.travels),
      ];
      return activities.sort((a, b) => {
        const date1 = utcToZonedTime(a.sortingDate, a.time_zone || "UTC");
        const date2 = utcToZonedTime(b.sortingDate, b.time_zone || "UTC");
        return date1 > date2 ? 1 : -1;
      });
    },
    sortedPosts: (state) => {
      const posts = [
        ...Object.values(state.feed),
        ...Object.values(state.polls),
        ...Object.values(state.scheduled),
      ];
      return posts.sort((a, b) => (a.date < b.date ? 1 : -1));
    },
    tripCompany: (state, _, rootState) => {
      const { trip } = state;
      console.log("getting trip company");
      console.log(trip);
      if (!trip || !trip.company) return null;
      console.log(rootState.companies);
      return rootState.companies[trip.company];
    },
    allUsers: (state, _, rootState) => {
      const { trip } = state;
      const travelers = [];
      if (!trip) return travelers;
      const allUsers = rootState.users;
      const tripUserIds = Object.keys(trip.user_ids);
      return tripUserIds.map((id) => allUsers[id]).filter((u) => u);
    },
    nonAdmins: (state, _, rootState) => {
      const { trip } = state;
      const normalUsers = [];
      if (!trip) return normalUsers;
      const allUsers = rootState.users;

      Object.keys(allUsers).forEach((key) => {
        if (trip.user_ids[key] === false) {
          normalUsers.push(allUsers[key]);
        }
      });
      return normalUsers;
    },
    admins: (state, _, rootState) => {
      const { trip } = state;
      const normalUsers = [];
      if (!trip) return normalUsers;
      const allUsers = rootState.users;

      Object.keys(allUsers).forEach((key) => {
        if (trip.user_ids[key]) {
          normalUsers.push(allUsers[key]);
        }
      });
      return normalUsers;
    },
    currentTripId: (state) => {
      if (state.trip) return state.trip.id;
      return null;
    },

    conversationWithPartner: (state, _, rootState) => (partner) => {
      const meId = rootState.firUser.uid;
      return Object.values(state.chats).find((chat) => {
        const members = Object.keys(chat.users);
        return !chat.name && members.length === 2 &&
          members.includes(meId) && members.includes(partner);
      });
    },
  },
  actions: {
    // observeFeed: (context) => {
    //     console.log("observeFeed")
    //     if (!context.state.observingFeed) {
    //         firestore.observeFeed(context, context.getters.currentTripId)
    //     } else {
    //         console.log("joking! already observing")
    //     }
    // },
    observeNewTrip: (context, tripId) => {
      console.log('observing trip');

      const { trip } = context.state;
      if (trip) {
        notifications.notificationsEnabled(false);
        database.stopObservers();
        firChat.stopObservers();
        firestore.unsubscribeListeners();
        const userIds = Object.keys(trip.user_ids);
        context.commit('deleteTripUsers', userIds, { root: true });
      }
      context.commit('deleteTrip');
      firestore.observeTrip(context, tripId);
      database.observeTrip(context, tripId);
      setTimeout(() => {
        console.log("timeout trip.js");
        notifications.checkPermissions();
        notifications.notificationsEnabled(true);
      }, 5000);
    },
    observeTripUsers: (context, trip) => {
      console.log('observing users');
      database.observeUsers(context, trip.user_ids);
      const users = Object.keys(context.rootState.users);
      database.getUsers(context, Object.keys(trip.removed_users || {})
        .filter((uId) => users.includes(uId)));
      database.getUsers(context, Object.keys(trip.user_requests || {})
        .filter((uId) => users.includes(uId)));
    },
  },
};

export default tripModule;
